import React from "react";
import "./ArticleCard.css";

const ArticleCard = ({ image, title, body, id, link }) => {
  console.log(link)
  return (
<div className="card shadow-sm border-0 rounded">
  { image && <img src={image} alt={title} className="myimg" /> }
  <div className="card-body p-3">
    <h5 className="card-title my-title">{title}</h5>
    <div className="card-text small text-truncate-multiline"
      dangerouslySetInnerHTML={{ __html: body }}>
    </div>
    
    <a href={ link ? link : `/news-post/${id}` } className="btn btn-link text-primary p-0">
      Find out more 
    </a>
  </div>
</div>
  );
};

export default ArticleCard;


// WEBPACK FOOTER //
// src/components/AritcleCard/ArticalCard.js